import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'joinArray',
})
export class JoinArrayPipe implements PipeTransform {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform(value: any, separator = ', '): string {
    if (!value || !Array.isArray(value)) {
      return '-';
    }
    return value.join(separator);
  }
}
